module.exports = "https://cdn.dove.it/_next/static/public/assets/services/notaio_340x200.6d17e1f5b6f139f8c2148fbaaad5cb68.jpg";